export class Line {
    /**
     * start point of the line
     */
    public start_point: number[];

    /**
     * end point of the line (Treated as point if start_point and end_point is the same
     */
    public end_point: number[];
}